module.exports = __webpack_public_path__ + "static/media/facebook-footer.fd03862e.svg";